import React, { Component } from 'react';
import image1 from '../zigloi3.jpg'
import logo1 from '../logotest.jpg'
import image2 from '../zigloi1.jpg'
import logo2 from '../layout/banner2.jpeg'
import axios from 'axios';
import Config from '../Config'
import image3 from '../zigloi.jpg'
import logo3 from '../analysi.png'
import ReactDOM from "react-dom";
import RBCarousel from "react-bootstrap-carousel";
//import { Row, Col, Button, ButtonGroup } from "../bootstrap-component.jsx";
//import "react-bootstrap-carousel/dist/bootstrap.min.css";
import Modal from 'react-awesome-modal';
import { Route, Link, Switch, BrowserRouter as Router } from 'react-router-dom'


const styles = { height: 400, width: "100%" };
const icon_glass = <span className="glyphicon glyphicon-glass" />;
const icon_music = <span className="glyphicon glyphicon-music" />;

let content = [{
  image: image1, title: "SupportHQ Core Banking Platform",
  description: "SupportHQ is a relatively low-cost real time integrated web/cloud based micro-banking platform which enables microfinance companies and other financial institutions as well as credit unions in the informal sector manage their client’s information and back office operations while providing a critical source of aggregate financial data on the informal sector."
},
{ image: "eSpyon Cash Mobilization Platform", title: "", description: "" },
{ image: "", title: "", description: "" }]
export default class Home extends Component {

  constructor (props) {
    super(props);
    this.config = new Config()
    this.$http = this.config.DConnect()

    this.slider = React.createRef();
    this.state = {
      autoplay: true, visible: false, ticketid: '',
      faq: []
    };
  }

  componentDidMount() {
    this.getFaq()
  }
  _onSelect = (active, direction) => {
    console.log(`active=${active} && direction=${direction}`);
  };
  _visiableOnSelect = (active) => {
    console.log(`visiable onSelect active=${active}`);
  };
  _slideNext = () => {
    this.slider.current.slideNext();
  };
  _slidePrev = () => {
    this.slider.current.slidePrev();
  };
  _goToSlide = () => {
    this.slider.current.goToSlide(1);
  };
  _autoplay = () => {
    this.setState({ autoplay: !this.state.autoplay });
  };
  _changeIcon = () => {
    let { leftIcon, rightIcon } = this.state;
    leftIcon = leftIcon ? undefined : icon_glass;
    rightIcon = rightIcon ? undefined : icon_music;
    this.setState({ leftIcon, rightIcon });
  };

  openModal() {
    this.setState({
      visible: true
    });
  }

  closeModal() {
    this.setState({
      visible: false
    });
  }

  handleChange = (e) => {
    let ticketid = this.state.ticketid
    ticketid = e.target.value
    this.setState({ ticketid })

  }
  submitForm = () => {
    this.props.history.push('/chatpage/' + this.state.ticketid);
    window.location.reload(true)
  }

  getFaq = () => {
    this.$http.get('category/fetchallknowledgebase/FAQ')
      .then(res => {
        let dataitm = res.data
        let faq = dataitm.slice(0, 6)
        this.setState({ faq })
      })
  }

  render() {
    let trClose = () => this.setState({ show: false })
    return (
      <div>
        <section class="banner-2 " style={{ backgroundImage: `url(${logo2})` }}>
          <div class="container">
            <div class="banner-content-2">
              <h1 class="title cl-white">How Can We Help You?</h1>
              <p class=" cl-white">Have questions? Search through our Help Center.</p>
              <form class="search-form round">
                <input type="text" onChange={this.handleChange} value={this.state.ticketid} placeholder="Start typing your search…" />
                <button type="submit" onClick={this.submitForm}><i class="flaticon-search"></i> <span class="d-none d-sm-inline-block">Search</span></button>
              </form>
            </div>
          </div>
        </section>

        <div class="how-search-section padding-bottom mt--93">
          <div class="container">
            <div class="row mb-30-none justify-content-center">
              <div class="col-sm-10 col-md-6 col-lg-4">
                <div class="how-search-item no-border">
                  <div class="thumb">
                    <img src="./assets/images/how/how1.png" alt="how" />
                  </div>
                  <div class="content">
                    <h4 class="title"><a href="#/faq">How to use SupportHQ</a></h4>
                    <p>Helpful information on how to use SupportHQ.</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-10 col-md-6 col-lg-4">
                <div class="how-search-item no-border">
                  <div class="thumb">
                    <img src="./assets/images/how/how2.png" alt="how" />
                  </div>
                  <div class="content">
                    <h4 class="title"><a href="#" onClick={() => this.openModal()}>View Existing Tickets</a></h4>
                    <p>Follow up on your old tickets or check you mail!</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-10 col-md-6 col-lg-4">
                <div class="how-search-item no-border">
                  <div class="thumb">
                    <img src="./assets/images/how/how3.png" alt="how" />
                  </div>
                  <div class="content">
                    <h4 class="title"><a href="/admin">Ticket System</a></h4>
                    <p>Login as Administrator to solve issues faster than ever.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="knowledge-section padding-bottom">
          <div class="container">
            <div class="section-header">
              <h2 class="title">FAQ</h2>
              <p>Explore How-To's and learn best practices from our FAQ.</p>
            </div>
            <div class="row justify-content-center mb-30-none">
              {(this.state.faq == '') ? <span className='fa fa-spinner fa-spin'></span> :
                this.state.faq.map(itm => (
                  <div class="col-lg-6 col-md-10">
                    <div class="knowledge-item">
                      <div class="knowledge-thumb">
                        <img src="./assets/images/knowledge/know1.png" alt="knowledge" />
                      </div>
                      <div class="knowledge-content">
                        {/* <h4 class="title"><a href="#0">Get started</a></h4> */}
                        <p>{itm.subject} </p>
                      </div>
                    </div>
                  </div>
                )
                )
              }


              {/* <div class="col-lg-6 col-md-10">
                    <div class="knowledge-item">
                        <div class="knowledge-thumb">
                            <img src="./assets/images/knowledge/know2.png" alt="knowledge"/>
                        </div>
                        <div class="knowledge-content">
                            <h4 class="title"><a href="#0">Configuring Automations</a></h4>
                            <p>Set up your account, configure support channels, customize your portal to reflect your brand and more. </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-10">
                    <div class="knowledge-item">
                        <div class="knowledge-thumb">
                            <img src="./assets/images/knowledge/know3.png" alt="knowledge"/>
                        </div>
                        <div class="knowledge-content">
                            <h4 class="title"><a href="#0">Customer Portal Setup</a></h4>
                            <p>Set up your account, configure support channels, customize your portal to reflect your brand and more. </p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-10">
                    <div class="knowledge-item">
                        <div class="knowledge-thumb">
                            <img src="./assets/images/knowledge/know4.png" alt="knowledge"/>
                        </div>
                        <div class="knowledge-content">
                            <h4 class="title"><a href="#0">Advanced Configurations</a></h4>
                            <p>Set up your account, configure support channels, customize your portal to reflect your brand and more. </p>
                        </div>
                    </div>
                </div> */}

            </div>
            {/* <div class="load-wrapper">
                <a href="#0" class="load-more">View All Categories</a>
            </div> */}
          </div>
        </section>

        <Modal
          visible={this.state.visible}
          width="400"
          height="400"
          effect="fadeInLeft"

          onClickAway={() => this.closeModal()}
        >
          <div style={{ paddingTop: "30px" }}>
            <h4>Search Ticket</h4>
            <br></br>
            <form>
              <div class="form-group col-md-10 " style={{ marginLeft: "30px" }}>
                <label for="exampleInputEmail1">Ticket Id</label>
                <input type="text" class="form-control" name="ticketid" id="exampleInputEmail1" onChange={this.handleChange} value={this.state.ticketid} aria-describedby="emailHelp" placeholder="Enter Ticket Id..." />
              </div>

            </form>

          </div>
          <div className="btn-group" >
            <button bsSize="small" className="btn btn-danger" onClick={() => this.closeModal()}> Cancel</button>
            <button bsSize="small" className="btn btn-success" onClick={this.submitForm}>  Search </button>
          </div>
        </Modal>
      </div>
    )
  }
}